import template from './exploreDataHeaderNg1.jade';

class ExploreDataHeaderNg1Controller {
  constructor(currentExploreGroup, exploreBenchmarkSnapshotSubject, exploreFilteredSnapshotDataSubject) {
    this.group = {};
    this.currentExploreGroup = currentExploreGroup;
    this.baseFilteringFactor = 0.75;

    exploreBenchmarkSnapshotSubject.subscribe((unfilteredExploreSnapshot) => {
        if(unfilteredExploreSnapshot != null) {
          this.usersNumber = unfilteredExploreSnapshot.number_of_users;
        }
    });
    exploreFilteredSnapshotDataSubject.subscribe((filteredExploreSnapshot) => {
        if(filteredExploreSnapshot != null) {
          this.usersNumber = filteredExploreSnapshot.number_of_users;
        }
    });

    currentExploreGroup.subscribe((group) => {
      if(group != null) {
        this.group = group;
        this.groupNamePristine = group.name;
      }
    });

    this.isEditingGroupName = false;
  }

  generateFilteredUsersNumber(exploreGroup) {
    let numberOfModifiedFilters = 0;
    exploreGroup.acquisition_source.length > 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.active_days[0] != 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.age.length > 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.app_intesity[0] != 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.apps.length > 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.countries.length > 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.genres.length > 0 ? numberOfModifiedFilters++ : null;
    this.getXor(exploreGroup.is_android, exploreGroup.is_ios) ? numberOfModifiedFilters++ : null;
    this.getXor(exploreGroup.is_phone, exploreGroup.is_tablet) ? numberOfModifiedFilters++ : null;
    this.getXor(exploreGroup.is_female, exploreGroup.is_male) ? numberOfModifiedFilters++ : null;
    exploreGroup.is_paying ? numberOfModifiedFilters++ : null;
    exploreGroup.other_apps[0] != 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.payment_amount[0] != 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.registration_date != null ? numberOfModifiedFilters++ : null;
    exploreGroup.sessions_per_day[0] != 0 ? numberOfModifiedFilters++ : null;
    exploreGroup.transactions[0] != 0 ? numberOfModifiedFilters++ : null;
      
    let filteringFactor = Math.pow(this.baseFilteringFactor, numberOfModifiedFilters + 1);
    return this.usersNumber = this.totalUsersNumber * filteringFactor;
  }

  getXor(value1, value2) {
    return value1 ? !value2 : value2;
  }

  get isGroupTitleEditAllowed() {
    return this.group.id || this.areFiltersModified;
  }

  get isToBeSaved() {
    return this.areFiltersModified || this.isTitleModified;
  }

  get isTitleModified() {
    return this.group.name != this.groupNamePristine;
  }

  editGroupName() {
    this.isEditingGroupName = true;
  }

  stopEditGroupName() {
    this.isEditingGroupName = false;
  }
}

let ExploreDataHeaderNg1Component = {
  template: () => { return template },
  controller: ExploreDataHeaderNg1Controller,
  controllerAs: 'vm',
  bindings: {
    areFiltersModified: "=?",
    visualizationMode: "=",
    totalUsersNumber: "="
  }
};

export default angular.module('app.components.explore.data-header', [])
  .component('exploreDataHeaderNg1', ExploreDataHeaderNg1Component);



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreDataHeaderNg1.js
 **/